"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const every_1 = __importDefault(require("lodash/every"));
const filter_1 = __importDefault(require("lodash/filter"));
const get_1 = __importDefault(require("lodash/get"));
const filterByMake_1 = __importDefault(require("../filterByMake"));
const filterByTransmission_1 = __importDefault(require("../filterByTransmission"));
const isFilterCriteriaEmpty_1 = __importDefault(require("../isFilterCriteriaEmpty"));
/**
 * Filters the fleet group by categories
 * @param {FilterCriteriaType} filterCriteria
 * @param {Array} fleetArr
 * @returns {Array}
 */
function filterFleet(filterCriteria, fleetArr) {
    if ((0, isFilterCriteriaEmpty_1.default)(filterCriteria)) {
        return fleetArr;
    }
    return (0, filter_1.default)(fleetArr, (fleet) => {
        return (0, every_1.default)(filterCriteria, (criteriaArr, filterKey) => {
            if (filterKey === 'make') {
                const fleetMake = (0, get_1.default)(fleet, 'make', '').toLowerCase().trim();
                return (0, filterByMake_1.default)(criteriaArr, fleetMake);
            }
            if (filterKey === 'class') {
                const fleetClass = (0, get_1.default)(fleet, 'class', '').toLowerCase().trim();
                return (0, filterByMake_1.default)(criteriaArr, fleetClass);
            }
            if (filterKey === 'transmission') {
                const fleetTransmission = (0, get_1.default)(fleet, 'transmission', '')
                    .toLowerCase()
                    .trim();
                return (0, filterByTransmission_1.default)(criteriaArr, fleetTransmission);
            }
            return true;
        });
    });
}
exports.default = filterFleet;
